export default __webpack_public_path__ + "static/media/IMG_00003.f3e68eef.jpeg";